import Australia from './Australia';
import Brazil from './Brazil';
import Canada from './Canada';
import Denmark from './Denmark';
import EuropeanUnion from './EuropeanUnion';
import GreatBritain from './GreatBritain';
import HongKong from './HongKong';
import India from './India';
import Israel from './Israel';
import Japan from './Japan';
import Mexico from './Mexico';
import NewZealand from './NewZealand';
import Norway from './Norway';
import Poland from './Poland';
import Singapore from './Singapore';
import SouthAfrica from './SouthAfrica';
import Switzerland from './Switzerland';
import UnitedStates from './UnitedStates';

/*
  - Flag SVGs ported & adapted from https://github.com/hampusborgos/country-flags/ and/or wikimedia
  - Run yarn lint --fix to format props alphabetically for new SVGs
*/

export const flags = {
  Australia,
  Brazil,
  Canada,
  Denmark,
  EuropeanUnion,
  GreatBritain,
  HongKong,
  India,
  Israel,
  Japan,
  Mexico,
  NewZealand,
  Norway,
  Poland,
  Singapore,
  SouthAfrica,
  Switzerland,
  UnitedStates,
};
